export default __webpack_public_path__ + "static/media/thumb-Nacic-Clock-4.52b4bddb.png";